import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

if (process.env.NODE_ENV == "production") {
  Sentry.init({
    dsn: "https://73b10b700e0145ad9b05c216e8a4530d@o1038394.ingest.sentry.io/6006707",
    integrations: [new Integrations.BrowserTracing()],
    release: `${APP_NAME}@${APP_VERSION}`,

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.8,
  });

  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/wp-content/themes/sonicboomtheme/react/service-worker.js")
        .then((registration) => {
          console.log("SW registered: ", registration);
        })
        .catch((registrationError) => {
          console.log("SW registration failed: ", registrationError);
        });
    });
  }
}

const container = document.querySelector("#reactApp");
if (!container) throw new Error("Could not find React root!");

const root = createRoot(container);
root.render(React.createElement(App));
